import {
    ArticleAvailableEvent,
    BreachEvent,
    EntitledToView,
    PublicationType,
    RequiredAccess,
} from '@news-mono/web-common'
import H from 'history'
import React from 'react'
import {
    BreachNotificationWrapper,
    useBreachWallConfig,
} from './components/BreachNotificationWrapper/BreachNotificationWrapper'
import { createIsEntitledChangeHandler } from './createIsEntitledChangeHandler'
import { StyledFeatureArticleBreachNotification } from './FeatureArticleBreach.styled'

export interface FeatureArticleBreachProps {
    requiredAccess: RequiredAccess
    location: H.Location
    commonElements: React.ReactElement<any>
    comments?: React.ReactElement<any>
    onEvent: (event: BreachEvent | ArticleAvailableEvent) => void
    article: PublicationType
}

export const FeatureArticleBreach: React.FC<FeatureArticleBreachProps> = (
    props,
) => {
    const {
        commonElements,
        comments,
        requiredAccess,
        location,
        onEvent,
        article,
    } = props

    const { creativeName, deal, type } = useBreachWallConfig(location)

    return (
        <EntitledToView
            requiredAccess={requiredAccess}
            articleSlug={article.slug}
            onIsEntitledChange={createIsEntitledChangeHandler(
                creativeName,
                deal,
                location,
                onEvent,
                article,
            )}
            entitled={() => {
                return (
                    <div>
                        {commonElements}
                        {props.children}
                        {comments}
                    </div>
                )
            }}
            notEntitled={() => {
                return (
                    <div>
                        {commonElements}
                        <StyledFeatureArticleBreachNotification>
                            <BreachNotificationWrapper
                                publication={article}
                                requiredAccess={requiredAccess}
                                breachDeal={deal}
                                breachCreativeName={creativeName}
                                onEvent={onEvent}
                                type={type}
                            />
                        </StyledFeatureArticleBreachNotification>
                        {comments}
                    </div>
                )
            }}
        />
    )
}

FeatureArticleBreach.displayName = 'FeatureArticleBreach'
